import { of as observableOf, Observable } from 'rxjs';
import { Injectable, Output, EventEmitter } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Location } from '@angular/common';
import { Router } from "@angular/router";
import { AppConfigService } from './app-config.service';

declare var bootbox: any;
//import 'rxjs/Rx';

@Injectable()
export class AJWebService {
    //SAAS
    public SaasDetails:any=[];
    public hometouseraccess:boolean=false;
    public Saas = new EventEmitter<any>();
    public userlist:any=[];
    public scope_title:string=''
    public instancetype='';

    //DSDC
    public Token: string;
    public ExpirationDate: string;
    public enterpriseId: string;
    public ExternalURLs: any[] = [];
    public ClientDeliveryStructure: any[] = [];
    public clientName: string;
    public EndToEndUId: string;
    public AJBaseURL: string;
    public appSettingResponse: unknown[];
    public IsDSDCLoaded: boolean = false;
    public DeliveryStructures: any[] = [];
    public ScopeSelectorValueTemp: string;
    public SelectedDC: any[] = [];
    public SelectedDeliveryStructure: any[] = [];
    public scopeselectedlevel: any[] = [];
    public selectedAssociatedDCIdIOM: string;
    public scopeselectedlevelTemp = [{ URL: "", Text: "", Level: "Client" }, { URL: "", Text: "", Level: "DS" }, { URL: "", Text: "", Level: "ADC" }, { URL: "", Text: "", Level: "DC" }];
    public IOMRedirectUrl: any;

    public updateScopeSelector = new EventEmitter<{ cmsOrWS, cmsOrWSUid, wsUid, cmsOrWSId }>();


    public displayTicketVolumeGraphPopUp = new EventEmitter<string>();
    public displaySavingsGraphPopUp = new EventEmitter<string>();

    //  public enterpriseId: string;
    public endToEndUId: string;
    public clientWMSId: string;

    public tabCode: string;
    public FilteredCMSWSRequest: any;
    public LoadOpportunityRequest: any;
    public CMSUId: string;
    public WorkstreamUId: string;
    public queryString: any;
    public role: string;
    public ScopeSelectorLoaded: boolean;
    public isError: boolean;
    public ErrorMessage: string;
    public DAvisible: boolean;
    public LaunchAnalyservisible: boolean;
    public userSpecificUsage: string;
    public apRedirectURL: any;

    public plannedTotalEfforts: any;
    public costPerHour: any;
    public actualTotalSavings: any;
    public plannedTotalSavings: any;
    public outcomesDataCalculationCompleted = new EventEmitter<string>();

    public ticketVolumeDataUpdated = new EventEmitter<string>();
    public savingsAndFTEDataUpdated = new EventEmitter<string>();
    public lastActiveOpportunityId: number;

    public showAutomationOpportunitiesData = new EventEmitter<string>();
    public ticketDistributionData = [];
    public ticketDistributionDataLoaded = new EventEmitter<string>();
    public opportunityQueues: any[][] = [];
    public opportunityQueuesLoaded = new EventEmitter<string>();
    public showTicketDistributionChartInPopUp = new EventEmitter<string>();
    public showUseCasesImplementationChartInPopUp = new EventEmitter<string>();

    public backlogList: any[] = [];
    public inProgressList: any[] = [];
    public completedList: any[] = [];
    public cancelledList: any[] = [];
    public SelectedDeliveryConstructId: any;


    // enterpriseId(enterpriseId: any, endToEndUId: any, clientWMSId: any) {
    //   throw new Error("Method not implemented.");
    // }
    // endToEndUId(enterpriseId: any, endToEndUId: any, clientWMSId: any) {
    //   throw new Error("Method not implemented.");
    // }
    // clientWMSId(enterpriseId: any, endToEndUId: any, clientWMSId: any) {
    //   throw new Error("Method not implemented.");
    // }
    public baseURL: string;
    public environmentDetails: any;

    @Output() change: EventEmitter<boolean> = new EventEmitter();
    @Output() changeToken: EventEmitter<string> = new EventEmitter();
    @Output() changeScope: EventEmitter<any> = new EventEmitter();
    constructor(location: Location, router: Router, private http: HttpClient, private appConfig: AppConfigService, private route: Router) {
        this.environmentDetails = this.appConfig.environmentSettings;
        if (this.environmentDetails.production)
            this.baseURL = this.environmentDetails.serverAPIUrl;
        else
            this.baseURL = "http://localhost:63479/";
            //this.baseURL = "https://mywizardaj-saasapi-stage.accenture.com/";

        this.ScopeSelectorLoaded = false;
        if (this.baseURL.includes("localhost")) {
            this.endToEndUId = "00050000-0000-0000-0000-000000000000";
            this.enterpriseId = "atish.rajesh.gandhi";
            this.tabCode = "MW";
        }
        else {
            this.queryString = window.location.href.split('/');
            //check
            if (this.queryString.length > 4)
                this.tabCode = this.queryString[4].toUpperCase();
            else
                this.tabCode = this.queryString[3].toUpperCase();
            //this.endToEndUId = this.queryString[this.queryString.length - 1].toLowerCase();
            this.endToEndUId = "00050000-0000-0000-0000-000000000000";
        }
    }

    setLoadOpportuityRequest(LoadOpportunityRequest: any) {
        this.LoadOpportunityRequest = LoadOpportunityRequest;
        this.change.emit(this.LoadOpportunityRequest);
    }

    APtoAJHeatMap<T>(clientID: string, dSId: string, dcId: string): Observable<T> {
        //SKM
        //var url = this.baseURL + "ENS/APtoAJHeatMap?clientID=" + clientID + "&dSId=" + dSId + "&dcId=" + dcId;
        // Need to pass AP API token: then call the below AP API to get the data        
        //return this.http.get<T>('https://mywizard-aiprojectmanagerapi.ciostage.accenture.com/Baseline/APtoAJHeatMap');
        //return this.http.get<T>('http://localhost:58779/Baseline/APtoAJHeatMap');
        return this.http.post<T>(this.baseURL + "ENS/APtoAJHeatMap",{
            "dSId":clientID,
            "dcId":clientID});
        //return this.http.get<T>(this.baseURL + "ENS/APtoAJHeatMap?endToEndUId=" + EndToEndUId);
    }

    GetProductList<T>(EndToEndUId: string): Observable<T> {
        return this.http.get<T>(this.baseURL + "AJ/ProductList/" + EndToEndUId);
    }

    GetAIAARAGStatus<T>(data: any): Observable<T> {
        return this.http.post<T>(this.baseURL + "/AIAARAGStatus", { data });
    }


    GetMigrateAiaa<T>(EndToEndUId: string): Observable<T> {
        return this.http.get<T>(this.baseURL + "AJ/MigrateAiaa/" + EndToEndUId);
    }

    GetMigrationStatus<T>(EndToEndUId: string): Observable<T> {
        return this.http.get<T>(this.baseURL + "AJ/MigrationStatus?EndToEndUId=" + EndToEndUId);
    }

    GetUserAccessSettings<T>(EndToEndUId: string): Observable<T> {
        return this.http.get<T>(this.baseURL + "AJ/GetEndToEndAccessSettings?EndToEndUId=" + EndToEndUId);
    }

    UpdateDueDate<T>(OpportunityId: any, PlannedDate: string): Observable<T> {
        return this.http.get<T>(this.baseURL + "AJ/AddPlannedDate/" + OpportunityId + "/" + PlannedDate );
    }

    UpdateDueDateAllOpportunities<T>(OpportunityId: number, PlannedDate: string): Observable<T> {
        return this.http.get<T>(this.baseURL + "AJ/AddPlannedDateforAllOpportunities?OpportunityId=" + OpportunityId + "&PlannedDate=" + PlannedDate);
    }

    getReport<T>(Contracts: any): Observable<T> {
        return this.http.post<T>(this.baseURL + "HPDP/GetReport", { Contracts });
    }

    getTicketVolume<T>(OpportunityId: number): Observable<T> {
        return this.http.get<T>(this.baseURL + "AJ/GetUsage/" + OpportunityId );
    }

    GetAssetAttributeUsage<T>(OpportunityId: number, AssetId: number): Observable<T> {
        return this.http.get<T>(this.baseURL + "AJ/GetAssetUsage/" + OpportunityId + "/" + AssetId);
    }

    saveAttributeUsageForTicketVolume<T>(data: any): Observable<T> {
        return this.http.post<T>(this.baseURL + "AJ/AddOrUpdateAttributeUsage", data );
    }

    saveValuesAndFTEforSavings<T>(data: any): Observable<T> {
        return this.http.post<T>(this.baseURL + "AJ/AddOrUpdateOpportunityValue", data );
    }

    UpdateCustomAssetOrderStatus<T>(assetId: number, endToEndId: number, assetName, assetType: string, orderStatus: string): Observable<T> {
        return this.http.get<T>(this.baseURL + "AJ/UpdateCustomAssetOrderStatus?assetId=" + assetId + '&endToEndUId=' + endToEndId + '&assetName=' + assetName + '&assetType=' + assetType + '&orderStatus=' + orderStatus );
    }

    UpdateAssetStatus<T>(assetId: number, status: string): Observable<T> {
        return this.http.post<T>(this.baseURL + "AJ/UpdateOrderStatus", { assetId, status } );
    }

    UpdateAssetCompletedStatus<T>(): Observable<T> {
        return this.http.get<T>(this.baseURL + "AJ/UpdateAssetCompletedStatus" );
    }

    UpdateOpportunityAssetStatus<T>(): Observable<T> {
        return this.http.get<T>(this.baseURL + "AJ/UpdateOpportunityAssetStatus" );
    }
    UpdateOppertunityStatus<T>(OpportunityId: string, Status: string): Observable<T> {
        return this.http.post<T>(this.baseURL + "AJ/UpdateOppertunityStatus", { OpportunityId, Status } );
    }

    GetNotificationsList<T>(data: any): Observable<T> {
        return this.http.post<T>(this.baseURL + "Notifications/TileNotifications/", data);
    }
    GetSaasProvision<T>(E2E): Observable<T> {
        return this.http.get<T>(this.baseURL + "SaaSIntegration/SaaSDetails/" +E2E );
    }
    GetSaaSUsers<T>(E2E): Observable<T> {
        return this.http.get<T>(this.baseURL + "SaaSIntegration/GetSaaSUsers/" +E2E );
    }
    CreateSaaSUser<T>(data): Observable<T> {
        return this.http.post<T>(this.baseURL + "SaaSIntegration/SaaSUser",data );
    }
    GetOpportunityList<T>(data: any): Observable<T> {
        return this.http.post<T>(this.baseURL + "AJ/OpportunityList", data);
    }

    GetAllOpportunityList<T>(data: any): Observable<T> {
        return this.http.post<T>(this.baseURL + "AJ/AllOpportunityList", { data });
    }

    AddToCart<T>(ProductUId: string, EndToEndUId: string): Observable<T> {
        return this.http.get<T>(this.baseURL + "MAS/AddProductToCart?ProductUId=" + ProductUId + "&EndToEndUId=" + EndToEndUId);
    }

    GetUsage<T>(opportunityId: number): Observable<T> {
        return this.http.get<T>(this.baseURL + "AJ/GetUsage" + opportunityId );
    }

    GetSavingsValue<T>(opportunityId: number): Observable<T> {
        return this.http.get<T>(this.baseURL + "AJ/GetValue/" + opportunityId );
    }

    getReviewers<T>(): Observable<T> {
        return this.http.get<T>(this.baseURL + "HPDP/Reviewers");
    }

    getClients<T>(enterpriseId: string, clientId: string, engagementId: string, projectId: string): Observable<T> {
        return this.http.get<T>(this.baseURL + 'HPDP/HPDP/ClientDetails?enterpriseId=' + enterpriseId + '&clientId=' + clientId + '&engagementId=' + engagementId + '&projectId=' + projectId);
    }

    getUserAccess<T>(enterpriseId: string): Observable<T> {
        return this.http.get<T>(this.baseURL + 'HPDP/ClientUser?userId=' + enterpriseId);
    }

    getClientHierarchy<T>(enterpriseId: string, EndToEndUId: string, clientWMSId: string): Observable<T> {
        return this.http.get<T>(this.baseURL + 'HPDP/GetClientHierarchy/' + enterpriseId + '/' + EndToEndUId + '/' + clientWMSId);
    }

    // scope selector start
    getWorkStreams<T>(EndToEndUId: string): Observable<T> {
        return this.http.get<T>(this.baseURL + 'HPDP/GetWorkStreams/' + EndToEndUId);
    }

    getProjectAttributes<T>(EndToEndUId: string): Observable<T> {
        return this.http.get<T>(this.baseURL + "HPDP/GetProjectAttributes/" + EndToEndUId);
    }
    // scope selector end

    getOGOUCSG<T>(enterpriseId: string): Observable<T> {
        return this.http.get<T>(this.baseURL + 'HPDP/GetOGOUCSG/' + enterpriseId + '/');
    }

    GetOGOUCSGNP<T>(EndToEndUId: string): Observable<T> {
        return this.http.post<T>(this.baseURL + "HPDP/GetOGOUCSGNP", { EndToEndUId });
    }

    getAJUserAccess<T>(EndToEndUId: string): Observable<T> {
        return this.http.get<T>(this.baseURL + 'AJ/GetUserAccess/' + EndToEndUId);
    }

    GetUsageScheduleInterval<T>(EndToEndUId: string): Observable<T> {
        return this.http.get<T>(this.baseURL + 'AJ/GetandCreateInterval/' + EndToEndUId);
    }

    SchedueleService<T>(UsageData: any): Observable<T> {
        return this.http.post<T>(this.baseURL + "AJ/RefreshUsageSchdule", { UsageData });
    }

    AddUsageServiceSchedule<T>(EndToEndUId: string, interval: string, StartDate: string): Observable<T> {
        var detail = { EndToEndUId: EndToEndUId, Interval: interval, StartDate: StartDate };
        return this.http.post<T>(this.baseURL + "AJ/AddUsageServiceSchedule", { detail });
    }

    UpdateAutomationJourney<T>(EndToEndUId: string, EnterpriseId: string, OpportunityId: any, PlanStatus: any): Observable<T> {
        //return this.http.post<T>(this.baseURL + "AJ/UpdateAutomationJourney", { EndToEndUId, EnterpriseId, OpportunityId, PlanStatus });
        return this.http.post<T>(this.baseURL + "AJ/UpdateAutomationJourney", { EndToEndUId: "00050000-0000-0000-0000-000000000000", EnterpriseId, OpportunityId, PlanStatus },{ 'headers': new HttpHeaders().set('requestverification', this.Token) });
    }

    GetSavingsDetails<T>(EndToEndUIds: string[], enterpriseid: string, SelectedOG: string, SelectedOU: string, SelectedCSG: string): Observable<T> {
        var EndToEndUIdsData = { EnterpriseId: enterpriseid, EndToEndUIds: EndToEndUIds, OG: SelectedOG, OU: SelectedOU, CSG: SelectedCSG };
        return this.http.post<T>(this.baseURL + "HPDP/GetSavingsDetails", { EndToEndUIdsData });
    }

    getUseCaseImplementedDetails<T>(apCatergoryId: any) {
        return this.http.get<T>(this.baseURL + 'AJ/UseCasesImplemented/' + apCatergoryId);
    }

    //sample post method from gtr
    saveAssignedTicketCategory<T>(lstSaveCategoryResolution: any, UserId: string): Observable<T> {
        return this.http.post<T>(this.baseURL + "/TicketServiceMongo/SaveAssignedTicketCategory", { lstSaveCategoryResolution, UserId });
    }

    DecryptToken<T>(): Observable<T> {
        return this.http.get<T>(this.baseURL + "Authentication/GetDecryptToken/");
    }
    ClearCookie<T>(): Observable<T> {
        return this.http.get<T>(this.baseURL + "Authentication/ClearCookie/");
    }
    ClearApiCache<T>(): Observable<T> {
        return this.http.get<T>(this.baseURL + "AJ/ClearCache/", { 'headers': new HttpHeaders().set('requestverification', this.Token), responseType: 'text' as 'json' });
    }
    setToken(Token: any) {
        this.Token = Token;
        this.changeToken.emit(this.Token);
    }
    setScope(Scope: any) {
        this.SelectedDC = Scope;
        this.changeScope.emit(this.SelectedDC);
    }
    AppSettings<T>(): Observable<T> {
        return this.http.get<T>(this.baseURL + "AJ/AppSettings/" );
    }

    DeliveryStructureAndConstructs<T>(): Observable<T> {
        return this.http.get<T>(this.baseURL + "DSDC/DeliveryStructureAndConstructs/" );
    }
    ATRLogOut<T>(data: any): Observable<T> {
        return this.http.post<T>(data, {});
    }


    showSuccessMessage(message: string) {
        bootbox.alert({
            title: "<span style='color: green;'>Success..!!</span>",
            message: message,
            closeButton: false
        }).find('.btn-primary').removeClass('btn').css({ 'padding': '6px 12px', 'border-radius': '4px', 'border': '1px solid transparent' });
    }

    displayErrorMessage(err) {
        if (err.error != undefined && typeof (err.error) == "string")
            this.showErrorMessage(err.error);
        else if (err.message != undefined)
            this.showErrorMessage(err.message);
        else if (err.error != undefined && err.error.title != undefined)
            this.showErrorMessage(err.error.title);
        else if (err.error != undefined && err.error.text != undefined)
            this.showErrorMessage(err.error.text);
        else if (err.error != undefined && err.error.value != undefined)
            this.showErrorMessage(err.error.value);
    }

    showErrorMessage(message: string) {
        bootbox.alert({
            title: "<span style='color: red;'>Errors..!!</span>",
            message: message,
            closeButton: false
        }).find('.btn-primary').removeClass('btn').css({ 'padding': '6px 12px', 'border-radius': '4px', 'border': '1px solid transparent' });
    }

    showInfoMessage(message: string) {
        bootbox.alert({
            title: "<span style='color: white;'>Info..!!</span>",
            message: message,
            closeButton: false
        }).find('.btn-primary').removeClass('btn').css({ 'padding': '6px 12px', 'border-radius': '4px', 'border': '1px solid transparent' });
    }

    showConfidentialityMessage(message: string) {
        bootbox.dialog({
            title: "<span style='color: #008; font-size:20px; border-color: white'>Confidential Information – Reminder</span>",
            message: message,
            closeButton: false,
            buttons: {
                ok: {
                    label: 'I Understand',
                    className: 'centerbutton btn-primary'
                }
            }
        }).find('.modal-content').css({ 'width': '580px', 'margin-top': '150px' })
            .find('.modal-header').css({ 'background-color': 'white', 'border-color': 'white' })
            .find('.modal-body').css({ 'padding': '1.25rem !important' })
    }

    showConfirmMessage(message: string) {
        bootbox.confirm({
            message: message,
            callback: function (result) { return result; /* result is a boolean; true = OK, false = Cancel*/ }
        }).find('.btn-primary').removeClass('btn').css({ 'padding': '6px 12px', 'border-radius': '4px', 'border': '1px solid transparent' });
    }

    dummyObservable<T>(): Observable<any> {
        return observableOf(1);
    }

    GetScopeDetails(E2E){
        this.GetSaasProvision(E2E).subscribe((data) => {
            this.SaasDetails = data;
            if (this.SaasDetails.length > 0) {
              // if (
              //   this.ajWebService.enterpriseId == this.ajWebService.SaasDetails[0].RequestorID
              // ) {
                this.scope_title =
                this.SaasDetails[0].ClientName + ' | ' + this.SaasDetails[0].E2EName;
                this.SelectedDC.push({
                  id: this.SaasDetails[0].E2EUID,
                  name: 'DS',
                  parentId: null,
                  deliveryStructureId: this.SaasDetails[0].E2EUID,
                });
                this.changeScope.emit(this.SelectedDC);
                this.GetSaaSUsers(E2E).subscribe(userlist=>{
                  this.userlist=userlist;
                  this.userlist = this.userlist.map(obj => obj.RequestorID);
                  const found = this.userlist.find(x=>x==this.enterpriseId);
                    if (this.enterpriseId == found) {
                      this.setScope(this.SelectedDC);
                    } else {
                        this.scope_title=''
                      this.route.navigateByUrl('/error');
                    }
                })
         
            } else {
              this.route.navigateByUrl('/error');
       
            }
          },err=>{
            console.log(err)
          });
         
    }
}

function responseType(arg0: string, Token: string, responseType: any, arg3: string): HttpHeaders | { [header: string]: string | string[]; } {
    throw new Error('Function not implemented.');
}

